const initialState = () => ({
  occurrences: [],
  answers: [],
  status: null,
  items: []
})

export default initialState
